import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import styles from './FreePoolAgsnModal.module.css';
import { statusStringMap } from '../../staticData';
import { AGGREGATE_STATUS } from '../../constants';
import { FreeePoolAggregatesTable } from '..';

const FreePoolAgsnModal = ({
  title,
  open,
  handleClose,
  classNames = {},
  handleSubmit,
  rowsData,
  lineBackgroundColor,
  submitButtonText = 'OK',
}) => {
  const ROW_HEIGHT = 38;
  const fixedColumns = [
    {
      width: 100,
      title: 'Destination',
      field: 'destination',
      enableSearch: false,
      enableFilter: false,
    },
    {
      width: 130,
      title: 'Part No.',
      field: 'materialNumberToMatch',
      enableSearch: false,
      enableFilter: false,
    },
    {
      width: 120,
      title: 'AgSN',
      field: 'agsn',
      enableSearch: false,
      enableFilter: false,
      render: row => (
        <div className={styles.subHeading}>
          {row.matchedMaterialFromFreePool.agsn}
        </div>
      ),
    },
    {
      width: 160,
      title: 'Part Description',
      field: 'materialDescription',
      enableSearch: false,
      enableFilter: false,
    },
    {
      width: 110,
      title: 'AgSN Status',
      field: 'status',
      enableSearch: false,
      enableFilter: false,
      render: row => {
        if (
          row.matchedMaterialFromFreePool.status ===
          AGGREGATE_STATUS.ASN_GENERATED
        )
          return (
            <span style={{ opacity: 0.5 }}>
              {statusStringMap[AGGREGATE_STATUS.ASN_GENERATED]}
            </span>
          );
        return statusStringMap[row.status];
      },
    },
  ];

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles.formContainer}>
          <div className={styles.formTitle}>
            <span>{title}</span>
            <div
              className={styles.formlLineDiv}
              style={{
                backgroundColor: lineBackgroundColor,
              }}
            />
          </div>
          <div className={styles.subHeading}>
            We found matching aggregates for some of the requirement
          </div>
          <div className={styles.freePoolAgsnCount}>
            ({rowsData.data.length}) Matched
          </div>
          <div className={styles.tableView}>
            <FreeePoolAggregatesTable
              columns={[...fixedColumns]}
              defaultColumns={[...fixedColumns]}
              rowHeight={ROW_HEIGHT}
              rows={rowsData.data}
              classNames={{
                tableHeaderClassName: styles.tableHeaderClassName,
                tableHeadCellClassName: styles.tableHeadCellClassName,
                tableClassName: styles.tableClassName,
              }}
            />
          </div>
          <div className={styles.bottomRow}>
            <div className={styles.submitModal}>
              <button
                onClick={() => {
                  handleSubmit();
                }}
                className={styles.submitBt}
              >
                {submitButtonText}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

FreePoolAgsnModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  classNames: PropTypes.shape({
    tableHeaderClassName: PropTypes.string,
    tableHeadCellClassName: PropTypes.string,
  }),
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  rowsData: PropTypes.arrayOf(
    PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      data: PropTypes.array.isRequired,
    }),
  ),
  lineBackgroundColor: PropTypes.string,
  submitButtonText: PropTypes.string,
};

export default FreePoolAgsnModal;
